import React from "react";
import { getIn } from "formik";
import { Moment } from "moment";
import { DatePicker as BaseDatePicker } from "@mui/x-date-pickers";
import { Box, FormControl, TextField, TextFieldVariants } from "@mui/material";

import { DATE_FORMAT } from "../../../constants";
import { InfoTitle, InputMessage, ContextualHelp } from "../index";

interface IProps {
  field: {
    name: string;
    value: Moment | null;
  };
  label: string;
  disabled: boolean;
  infoTitle: string;
  format: string;
  form: {
    errors: {
      /* eslint-disable @typescript-eslint/no-explicit-any */
      optionalObject: Record<string, any>;
    };
    touched: boolean;
    setFieldValue: (a: string, b: string) => string;
  };
  datePickerProps: Record<string, any>;
  contextualHelpText: string;
  contextualHelpProps: Record<string, any>;
  onChange: (a: any) => string;
  waringMessage?: string;
  variant: TextFieldVariants | undefined;
  maxDate?: Moment | null;
  minDate?: Moment | null;
}

const DatePicker = ({
  field,
  label,
  disabled,
  infoTitle,
  form: { errors, setFieldValue },
  datePickerProps = {},
  contextualHelpText,
  contextualHelpProps = {},
  onChange = (value) => setFieldValue(field.name, value),
  waringMessage,
  variant = "outlined",
  maxDate,
  minDate,
}: IProps): React.ReactElement => {
  const errorMessage = getIn(errors, field.name);

  return (
    <ContextualHelp title={contextualHelpText} {...contextualHelpProps} isDisableHoverListener>
      <FormControl style={{ width: "100%" }}>
        <BaseDatePicker
          label={label}
          disabled={disabled}
          {...field}
          onChange={onChange}
          inputFormat={DATE_FORMAT}
          value={field.value}
          maxDate={maxDate}
          minDate={minDate}
          renderInput={(params) => (
            <TextField
              {...datePickerProps}
              variant={variant}
              {...params}
              error={!!errorMessage}
              {...(waringMessage && { color: "warning" })}
            />
          )}
        />

        {infoTitle && <InfoTitle title={infoTitle} />}

        <Box
          sx={{
            left: 0,
            top: 55,
            position: "absolute",
            ...(datePickerProps.inputVariant === "standard" && { top: 55 }),
            ...(datePickerProps.size === "small" && { top: 40 }),
          }}
        >
          {(errorMessage || waringMessage) && (
            <InputMessage warning={waringMessage} error={errorMessage} />
          )}
        </Box>
      </FormControl>
    </ContextualHelp>
  );
};

export default DatePicker;
